import React, { useState, useEffect, useRef } from 'react';
import ArrowBack from '../../assets/icons/arrow-back.svg'
import Eye from '../../assets/icons/eye.svg'
import HideEye from '../../assets/icons/close-eye.svg'
import BlueLogo from '../../assets/images/blue-logo.svg'
import { Form } from 'react-bootstrap';
import 'primeicons/primeicons.css';
import { ChangePassword, checkOtpChangePassword, sendOtpChangePassword } from "../../utils/api"
import Loader from '../loader/loader'
import { Toast } from 'primereact/toast';
import useToastNotification from '../../hooks/useToastNotification';


function ChangePasswordFun() {
  const toast = useRef(null);
  const [mobileSection, setMobileSection] = useState(true)
  const [OTPSection, setOTPSection] = useState(false)
  const [mobileLoader, setMobileLoader] = useState(false)
  const [changePassLoader, setChangePassLoader] = useState(false)
  const [validated, setValidated] = useState(false);
  const [changePassValidated, setChangePassValidated] = useState(false);
  const [mobile, setMobile] = useState('')
  const [otp, setOtp] = useState('')
  const [password, setPassword] = useState('')
  const [time, setTime] = useState(240); // Initialize with 3 minutes (180 seconds)
  const [isActive, setIsActive] = useState(false);
  const [resendBtn, setResendBtn] = useState(true);
  const [typePassword, setTypePassword] = useState('password');


  const { showError, showSuccess } = useToastNotification();



  const getOTPPassword = async (e) => {

    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === true) {
      setTime(240)
      setIsActive(true);
      setResendBtn(true);
      setMobileLoader(true)

      try {
        if (mobile.length == 11 && mobile.startsWith("09")) {

          let res = await sendOtpChangePassword({
            mobile
          })
          if (res.data.isSuccess) {
            setMobileLoader(false)
            setMobileSection(false)
            setOTPSection(true)
          }

          else {
            setMobileLoader(false)
            let message = {
              text: res.data.message
            }
            showError(message)
          }
        } else {

          let message = {
            text: `لطفا شماره موبایل را صحیح وارد کنید.`
          }
          showError(message)
          setMobileLoader(false)



        }

      } catch (error) {
        setMobileLoader(false)
        let errorMessage = JSON.parse(error.response.data.error)
        let message = {
          text: errorMessage.error
        }
        showError(message)
      }
    }
    setValidated(true)

  }
  const changeMobile = () => {
    setMobileSection(true)
    setOTPSection(false)
  }
  const checkOtp = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === true) {
      setChangePassLoader(true)
      try {
        let res = await checkOtpChangePassword({
          mobile,
          otp
        })

        if (res.data.isSuccess) {
          changePass()
        }
        else {
          setChangePassLoader(false)
          let message = {
            text: res.data.message
          }
          showError(message)
        }
      } catch (error) {
        setChangePassLoader(false)
        let message = {
          text: 'خطا در ارتباط با سرور'
        }
        showError(message)
      }
    }
    setChangePassValidated(true)

  }
  const changePass = async (e) => {

    try {
      let res = await ChangePassword({
        mobile,
        password
      })

      if (res.data.isSuccess) {
        setChangePassLoader(false)
        window.location.href = '/'
      }
      else {
        setChangePassLoader(false)
        let message = {
          text: res.data.message
        }
        showError(message)
      }
    } catch (error) {
      setChangePassLoader(false)
      let message = {
        text: 'خطا در ارتباط با سرور'
      }
      showError(message)
    }
  }
  const showPassword = () => {
    setTypePassword('text')
  }
  const hidePassword = () => {
    setTypePassword('password')
  }


  //setTimer
  useEffect(() => {
    let timerId;
    if (isActive && time > 0) {
      timerId = setInterval(() => {
        setTime(prevTime => prevTime - 1);
      }, 1000);
    } else if (time === 0) {
      onTimerFinish(); // Call the function when the timer reaches 0
    }
    // Cleanup interval on component unmount or when time reaches 0
    return () => clearInterval(timerId);
  }, [isActive, time]);

  //finishTimer
  const onTimerFinish = () => {
    setResendBtn(false);
  }

  const formatTime = (time) => {
    const minutes = String(Math.floor(time / 60)).padStart(2, '0');
    const seconds = String(time % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;
  }


  return (
    <>
      <Toast ref={toast} />

      <div>
        <div className='body-login container'>
          {mobileSection &&
            <div className='login-card'>
              <button className='btn btn-primary d-flex back-btn' onClick={() => window.history.back()}> <img src={ArrowBack} className='ml-2' alt="" />بازگشت</button>

              <div className='item' style={{ marginTop: '6em' }}>
                <div className='d-flex align-items-center f-32 font-black color-primary title gap-2'><img src={BlueLogo} alt="" />به کادونا خوش آمدید</div>
                <h6 className='text-xl font-medium	color-primary2 mt-5'>جهت تغییر رمز عبور، شماره موبایل خود را وارد کنید.</h6>
                <Form className='mt-5' noValidate validated={validated} onSubmit={(e) => getOTPPassword(e)}>
                  <Form.Group controlId="text" >
                    <Form.Label style={{ fontWeight: '600' }}>شماره موبایل</Form.Label>
                    <Form.Control type="number" inputMode="numeric" required value={mobile} onChange={(e) => {
                      if (e.target.value.length <= 11) {
                        setMobile(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                      }
                    }}
                      onKeyDown={(e) => {

                        if (e.key === 'Enter') {
                          e.preventDefault(); // Prevent form submission
                          getOTPPassword(e); // Call login function
                        }
                      }} />
                  </Form.Group>
                  <button className='btn btn-primary w-100 mt-1 text-center mt-5' disabled={mobileLoader} type='submit' style={{ width: 'auto' }}>ورود {mobileLoader && <Loader />}</button>
                </Form>
              </div>
            </div>
          }


          {OTPSection &&
            <div className='login-card'>
              <button className='btn btn-primary d-flex back-btn' onClick={changeMobile}> <img src={ArrowBack} className='ml-2' alt="" />بازگشت</button>
              <div className='item' style={{ marginTop: '6em' }}>
                <div className='d-flex align-items-center f-32 font-black color-primary title gap-2'><img src={BlueLogo} alt="" />به کادونا خوش آمدید</div>
                <h6 className='text-xl font-medium	color-primary2 mt-5'>رمز عبور جدید و کد تایید ارسالی  برای شماره {mobile} را وارد کنید.</h6>
                <Form className='mt-5' noValidate validated={changePassValidated} onSubmit={(e) => checkOtp(e)}>
                  <Form.Group controlId="text" >
                    <Form.Label style={{ fontWeight: '600' }}>رمزعبور جدید</Form.Label>
                    <div className='input-icon'>
                      <Form.Control type={typePassword} required value={password} onChange={(e) => setPassword(e.target.value)}
                      />
                      {typePassword === 'password' ? <img src={Eye} alt="" onClick={showPassword} /> : <img src={HideEye} alt="" onClick={hidePassword} />}
                    </div>
                  </Form.Group>
                  <Form.Group controlId="postalCode">
                    <Form.Label className='mt-2' style={{ fontWeight: '600' }}>کد تایید</Form.Label>
                    <Form.Control className='number text-center' type="number" autocomplete="one-time-code" inputMode="numeric" required value={otp} onChange={(e) => {
                      if (e.target.value.length <= 6) {
                        setOtp(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                      }
                    }} onKeyDown={(e) => {

                      if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent form submission
                        checkOtp(e); // Call login function
                      }
                    }} />

                  </Form.Group>

                  <button type='button' disabled={resendBtn} className='btn w-100 text-center mt-2 number' onClick={getOTPPassword}> {resendBtn ? formatTime(time) : 'ارسال مجدد'}</button>
                  <button className='btn btn-primary mt-4 w-100 mt-1 text-center' disabled={changePassLoader} type='submit' style={{ width: 'auto' }}>ادامه {changePassLoader && <Loader />}</button>
                  <button type='button' className='btn w-100 text-center color-primary' onClick={changeMobile}>تغییر شماره موبایل</button>

                </Form>
              </div>
            </div>
          }

        </div>
      </div>


    </>
  )

}
export default ChangePasswordFun;
